var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_21",
    "data-name": "Union 21",
    d: "M4,19a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0H15a4,4,0,0,1,4,4V15a4,4,0,0,1-4,4ZM1.5,4V15A2.5,2.5,0,0,0,4,17.5H15A2.5,2.5,0,0,0,17.5,15V4A2.5,2.5,0,0,0,15,1.5H4A2.5,2.5,0,0,0,1.5,4ZM13.123,14.144V13.112a1.561,1.561,0,0,0-1.559-1.559H7.435a1.559,1.559,0,0,0-1.558,1.559v1.032a.506.506,0,0,1-1.012,0V13.112a2.569,2.569,0,0,1,2.569-2.569h4.129a2.573,2.573,0,0,1,2.57,2.569v1.032a.506.506,0,0,1-1.012,0ZM6.93,6.919A2.57,2.57,0,1,1,9.5,9.49,2.573,2.573,0,0,1,6.93,6.919Zm1.011,0A1.559,1.559,0,1,0,9.5,5.36,1.561,1.561,0,0,0,7.941,6.919Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/contactIcon.b78f67ba24fdc529dcd3117617d0525e.svg";
export { ForwardRef as ReactComponent };